import { PeriodFrequency } from '../../../../types/PeriodFrequency';
import { dateService } from '../../../../services/date';

export const getTimeIndexFromTimestamp = (timestamp: number): number =>
  Number(String(timestamp).slice(4));

export const getYearFromTimestamp = (timestamp: number): number =>
  Number(String(timestamp).slice(0, 4));

export const getFrequencyTimestamp = (date: Date, frequency: PeriodFrequency): number => {
  if (!dateService.isValid(date)) {
    console.warn('Invalid date provided to getFrequencyTimestamp:', date);
    return 0;
  }

  try {
    const utcDate = dateService.toUTC(date);
    const year = utcDate.getUTCFullYear();

    switch (frequency) {
      case 'Daily': {
        const startOfYear = new Date(Date.UTC(year, 0, 1));
        const daysDiff = Math.floor((utcDate.getTime() - startOfYear.getTime()) / (1000 * 60 * 60 * 24));
        const dayNumber = daysDiff + 1;
        return Number(year + String(dayNumber).padStart(4, '0'));
      }
      case 'Weekly': {
        const startOfYear = new Date(Date.UTC(year, 0, 1));
        const daysDiff = Math.floor((utcDate.getTime() - startOfYear.getTime()) / (1000 * 60 * 60 * 24));
        const dayNumber = daysDiff + 1;
        const week = dayNumber === 366 ? Math.floor(1 / 7 + 1) : Math.floor(dayNumber / 7 + 1);
        return Number(year + String(week).padStart(2, '0'));
      }
      case 'Monthly': {
        const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
        return Number(`${year}${month}`) - 1;
      }
      case 'Quarterly': {
        const quarter = Math.floor(utcDate.getUTCMonth() / 3) + 1;
        return Number(`${year}${quarter}`) - 1;
      }
      case 'Annual':
        return year;
      default: 
        return 0;
    }
  } catch (error) {
    console.error('Error in getFrequencyTimestamp:', error, { date, frequency });
    // Fallback to original calculation
    const year = date.getUTCFullYear();
    const startOfYear = new Date(Date.UTC(year, 0, 1));
    const daysDiff = Math.floor((date.getTime() - startOfYear.getTime()) / (1000 * 60 * 60 * 24));
    const dayNumber = daysDiff + 1;
    return Number(year + String(dayNumber).padStart(4, '0'));
  }
};
